// extracted by mini-css-extract-plugin
module.exports = {"center":"Convertor_center__Tteuy","hleperText":"Convertor_hleperText__1mUGz"};